/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminStockManageUserSummaryResVo
 */
export interface AdminStockManageUserSummaryResVo {
    /**
     * 库存 SKU 数
     * @type {number}
     * @memberof AdminStockManageUserSummaryResVo
     */
    skuCount?: number;
    /**
     * 可用库存数量
     * @type {number}
     * @memberof AdminStockManageUserSummaryResVo
     */
    availableItemQty?: number;
    /**
     * 冻结库存数量
     * @type {number}
     * @memberof AdminStockManageUserSummaryResVo
     */
    freezeItemQty?: number;
    /**
     * 待上架数量（未指定货位箱内商品数量合计）
     * @type {number}
     * @memberof AdminStockManageUserSummaryResVo
     */
    pendingShelfQty?: number;
    /**
     * 未指定货位的库存箱数量
     * @type {number}
     * @memberof AdminStockManageUserSummaryResVo
     */
    pendingShelfBoxCount?: number;
    /**
     * 仓储计费箱数
     * @type {number}
     * @memberof AdminStockManageUserSummaryResVo
     */
    totalBoxCount?: number;
    /**
     * 仓储计费体积(CBM)
     * @type {number}
     * @memberof AdminStockManageUserSummaryResVo
     */
    totalCbm?: number;
    /**
     * 今日预计保管费(韩币)
     * @type {number}
     * @memberof AdminStockManageUserSummaryResVo
     */
    todayStorageFeeKrw?: number;
    /**
     * 当月累计保管费(韩币)
     * @type {number}
     * @memberof AdminStockManageUserSummaryResVo
     */
    currentMonthStorageFeeKrw?: number;
    /**
     * 保管费欠费金额(韩币)
     * @type {number}
     * @memberof AdminStockManageUserSummaryResVo
     */
    unpaidStorageFeeKrw?: number;
    /**
     * 预存款余额(韩币)
     * @type {number}
     * @memberof AdminStockManageUserSummaryResVo
     */
    walletBalanceKrw?: number;
}

/**
 * Check if a given object implements the AdminStockManageUserSummaryResVo interface.
 */
export function instanceOfAdminStockManageUserSummaryResVo(value: object): value is AdminStockManageUserSummaryResVo {
    return true;
}

export function AdminStockManageUserSummaryResVoFromJSON(json: any): AdminStockManageUserSummaryResVo {
    return AdminStockManageUserSummaryResVoFromJSONTyped(json, false);
}

export function AdminStockManageUserSummaryResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminStockManageUserSummaryResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'skuCount': json['skuCount'] == null ? undefined : json['skuCount'],
        'availableItemQty': json['availableItemQty'] == null ? undefined : json['availableItemQty'],
        'freezeItemQty': json['freezeItemQty'] == null ? undefined : json['freezeItemQty'],
        'pendingShelfQty': json['pendingShelfQty'] == null ? undefined : json['pendingShelfQty'],
        'pendingShelfBoxCount': json['pendingShelfBoxCount'] == null ? undefined : json['pendingShelfBoxCount'],
        'totalBoxCount': json['totalBoxCount'] == null ? undefined : json['totalBoxCount'],
        'totalCbm': json['totalCbm'] == null ? undefined : json['totalCbm'],
        'todayStorageFeeKrw': json['todayStorageFeeKrw'] == null ? undefined : json['todayStorageFeeKrw'],
        'currentMonthStorageFeeKrw': json['currentMonthStorageFeeKrw'] == null ? undefined : json['currentMonthStorageFeeKrw'],
        'unpaidStorageFeeKrw': json['unpaidStorageFeeKrw'] == null ? undefined : json['unpaidStorageFeeKrw'],
        'walletBalanceKrw': json['walletBalanceKrw'] == null ? undefined : json['walletBalanceKrw'],
    };
}

export function AdminStockManageUserSummaryResVoToJSON(json: any): AdminStockManageUserSummaryResVo {
    return AdminStockManageUserSummaryResVoToJSONTyped(json, false);
}

export function AdminStockManageUserSummaryResVoToJSONTyped(value?: AdminStockManageUserSummaryResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'skuCount': value['skuCount'],
        'availableItemQty': value['availableItemQty'],
        'freezeItemQty': value['freezeItemQty'],
        'pendingShelfQty': value['pendingShelfQty'],
        'pendingShelfBoxCount': value['pendingShelfBoxCount'],
        'totalBoxCount': value['totalBoxCount'],
        'totalCbm': value['totalCbm'],
        'todayStorageFeeKrw': value['todayStorageFeeKrw'],
        'currentMonthStorageFeeKrw': value['currentMonthStorageFeeKrw'],
        'unpaidStorageFeeKrw': value['unpaidStorageFeeKrw'],
        'walletBalanceKrw': value['walletBalanceKrw'],
    };
}

